"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/* eslint-disable prefer-rest-params */
/* istanbul ignore next */
if (typeof Function.prototype.call === 'undefined') {
    Function.prototype.call = function (context) {
        context = context || window;
        context.fn = this;
        var args = __spread(arguments).slice(1);
        var result = context.fn.apply(context, __spread(args));
        delete context.fn;
        return result;
    };
}
/* istanbul ignore next */
if (typeof Function.prototype.apply === 'undefined') {
    Function.prototype.apply = function (context) {
        context = context || window;
        context.fn = this;
        var result;
        if (arguments[1]) {
            result = context.fn.apply(context, __spread(arguments[1]));
        }
        else {
            result = context.fn();
        }
        delete context.fn;
        return result;
    };
}
